import * as userRoutines from '../sagas/routines/userRoutines';

const initialState = {
    avatars: {},
    distinct_users: [],
    firebase: [],
    groups: {},
    users_loading: false,
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {

        case userRoutines.syncUserInfo.SUCCESS:
            return {
                ...state,
                firebase: action.payload,
            };


        default:
            return state;
    }
}
